import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { AuthService } from "./auth.service";

/**
 * @WhatItDoes A service to interact with CIAM user operations.
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class CiamUserService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param applicationSettings application settings for the URL
     * @param authService authentication service
     * @param toastsManager toast notification service
     */
    constructor(
        http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService
    ) {
        super(http, authService, toastsManager);
    }

    /**
     * Invites an external user by email
     * @param email The email address of the external user to invite
     * @returns Observable with the invitation result
     */
    inviteExternalUser(email: string): Observable<any> {
        return super.post(`${this.applicationSettings.apiUrl}ciamuser/InviteExternalUser`, JSON.stringify(email));
    }
}
